import { Avatar, Box, Divider, IconButton, MenuItem, Popover, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useState } from "react";
import { getRole } from "src/utils/roleUtils";
import account from "../../../_mock/account";
import { StorageKeys } from "../../../enums/StorageKeys.enum";

// ----------------------------------------------------------------------
/*
const MENU_OPTIONS = [
  {
    label: 'Home',
    icon: 'eva:home-fill',
  },
  {
    label: 'Profile',
    icon: 'eva:person-fill',
  },
  {
    label: 'Settings',
    icon: 'eva:settings-2-fill',
  },
];
*/
const MENU_OPTIONS = [];

export default function AccountPopover() {
	const [open, setOpen] = useState(null);

	const handleOpen = (event) => {
		setOpen(event.currentTarget);
	};

	const handleClose = () => {
		setOpen(null);
	};
	const logoutHandler = () => {
		handleClose();
		localStorage.removeItem(StorageKeys.token);
		window.location.href = "/";
	};

	const user = JSON.parse(localStorage.getItem("user"));

	return (
		<>
			<IconButton
				onClick={handleOpen}
				sx={{
					p: 0,
					...(open
						? {
								"&:before": {
									zIndex: 1,
									content: "''",
									width: "100%",
									height: "100%",
									borderRadius: "50%",
									position: "absolute",
									bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
								},
							}
						: {}),
				}}
			>
				<Avatar src={account.photoURL} alt="avatar" />
			</IconButton>

			<Popover
				open={Boolean(open)}
				anchorEl={open}
				onClose={handleClose}
				anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
				transformOrigin={{ vertical: "top", horizontal: "right" }}
				PaperProps={{
					sx: {
						p: 0,
						mt: 1.5,
						ml: 0.75,
						width: 180,
						"& .MuiMenuItem-root": {
							typography: "body2",
							borderRadius: 0.75,
						},
					},
				}}
			>
				<Box sx={{ my: 1.5, px: 2.5 }}>
					<Typography variant="subtitle2" noWrap>
						{getRole(user?.admin?.permissionLevel)}
					</Typography>
					<Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
						{JSON.parse(localStorage.getItem("user"))?.admin?.username || "Unknown User"}
					</Typography>
				</Box>

				<Divider sx={{ borderStyle: "dashed" }} />

				<Stack sx={{ p: 1 }}>
					{MENU_OPTIONS.map((option) => (
						<MenuItem key={option.label} onClick={handleClose}>
							{option.label}
						</MenuItem>
					))}
				</Stack>

				<MenuItem onClick={() => logoutHandler()} sx={{ m: 1 }}>
					Logout
				</MenuItem>
			</Popover>
		</>
	);
}
